import {ApiRouteMap, HostRepositoryStateName, RestAPIMethod} from 'constants/dataEnum';
import {callAPI, getBaseURL} from 'stores/business/commonBusiness';

// eslint-disable-next-line import/prefer-default-export
export const getSoftwareVersionAndUpdateInfo = async () => {
  const baseUrl = getBaseURL(HostRepositoryStateName.INSTRUMENT_CONTROL);
  const response = await callAPI(RestAPIMethod.GET, baseUrl, ApiRouteMap.GET_SOFTWARE_VER_AND_UPDATE_INFO);

  return response;
};
